var _excluded = ["className", "isStreamStopped"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classNames from "classnames";
import css from "./index.module.scss";
import { useStreamText } from "./useStreamText";
import React, { useEffect, useImperativeHandle } from "react";
export var StreamText = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    isStreamStopped = props.isStreamStopped,
    _props = _objectWithoutProperties(props, _excluded);
  var _useStreamText = useStreamText(_props),
    streaming = _useStreamText.streaming,
    streamContent = _useStreamText.streamContent,
    streamList = _useStreamText.streamList,
    stop = _useStreamText.stop;

  // 暴露子组件方法
  useImperativeHandle(ref, function () {
    return {
      stop: stop
    };
  });
  useEffect(function () {
    if (props.isStreamStopped) {
      stop(false);
    }
  }, [props.isStreamStopped]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className),
    "data-testid": "StreamText"
  }, _props.disabled || !streaming || isStreamStopped ? streamContent : streamList.map(function (value, index) {
    return /*#__PURE__*/React.createElement("span", {
      className: css["value"],
      key: "".concat(value).concat(index)
    }, value, " ");
  }));
});